import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import cookie from "react-cookies";
import { selectedLang, getMenu, updateEcartDetails, promotionalHeader } from "../../../actions";
import { addClass, getRouting, removeClass, checkTickerUrls} from "../../../../utils/common";
// import Navigation from "./Navigation/index_new";
import MobileNavbar from "./Navigation/MobileNavbar";
import WragMenu from "./WragMenu/index_new";
import ActionMenu from "./ActionMenu/index_new";
import Notifications from "./ActionMenu/notifications";
import Logo from "./Logo/index_new";
import "./style.scss";
import { closePopup, openPopup } from "../Modal/action";
import { MODALS } from "../Modal/constants";

const Header = (props) => {
  useEffect(() => {
    getMenu();
  }, []);

  const {
    getMenus,
    commonContent,
    updatesAndNotifications,
    lofinMenu,
    location,
    closePopup,
    openPopup,
    promotionalHeader,
    promotionalBannerTop
  } = props;

  const isProductSolution = window.location.pathname.includes("product-solutions/overview");
  const [leftMenu, setLeftMenu] = useState();
  const [notificationData, setNotificationData] = useState();
  const [cartDetailCookie, setCartDetailCookie] = useState(null);
  const [isDesktop, setIsDesktop] = useState(true);
  const [homepagePromotionalData, sethomepagePromotionalData] = useState();

  useEffect(() => {
    const handleWindowSizeChange = () => {
      setIsDesktop(window.innerWidth > 991);
    };

    window.addEventListener('resize', handleWindowSizeChange);
    handleWindowSizeChange(); // Call the function initially to set the initial state

    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    };
  }, []);

  useEffect(() => {
    setCartDetailCookie(
      cookie.load("CartDetails") ? cookie.load("CartDetails") : {}
    );
  }, [commonContent.cartCount]);

  useEffect(() => {
    !(promotionalBannerTop && promotionalBannerTop.code && promotionalBannerTop.code == 200) && promotionalHeader();
  }, []);

  useEffect(() => {
    if (getMenus !== undefined) {
      setLeftMenu(getMenus);
    }
    if (updatesAndNotifications !== undefined) {
      setNotificationData(updatesAndNotifications);
    }
    if (promotionalBannerTop !== undefined) {
      sethomepagePromotionalData(promotionalBannerTop && promotionalBannerTop.data);
    }
  }, [commonContent]);

  const color = localStorage.getItem("colorContrast");
  const onAddToCart = (e) => {
    e.stopPropagation();
    let modalData = {
      closePopup: closePopup,
      modalClass: 'ecart-modal',
      joruneyPage: 3,
    };
    openPopup(MODALS.ECART_MODAL, modalData);
    cookie.save("isInvest", false, { path: "/" });
    cookie.save("isJanNivesh", false, { path: "/" });
  } 

  const lightDarkCookie = cookie.load("colorContrast");
  const [lightDarkMode, setLightDarkMode] = useState(lightDarkCookie);
  useEffect(() => {
    if (lightDarkCookie == "Dark") {
      setLightDarkMode(false);
    }
    if (lightDarkCookie == "Light") {
      setLightDarkMode(true);
    }
  }, [lightDarkCookie]);

  const handleColorChange = (e) => {
    setLightDarkMode(e.target.checked);
    let colorContrast = e.target.checked == true ? "Light" : "Dark";
    let cookieTime = 365 * 24 * 60 * 60;
    cookie.save("colorContrast", colorContrast, {
      path: "/",
      maxAge: cookieTime,
      sameSite: "strict",
    });
    if (colorContrast != undefined && colorContrast == "Dark") {
      document.body.classList.add("darkMode");
    }
    if (colorContrast != undefined && colorContrast == "Light") {
      document.body.classList.remove("darkMode");
    }
  };

  if (
    cookie.load("colorContrast") != undefined &&
    cookie.load("colorContrast") == "Dark"
  ) {
    document.body.classList.add("darkMode");
  }
  if (
    cookie.load("colorContrast") != undefined &&
    cookie.load("colorContrast") == "Light"
  ) {
    document.body.classList.remove("darkMode");
  }

  // useEffect(() => {
  //   var size = parseInt($("p").css("font-size"));
  //   $(".smallText").on("click", function () {
  //     size -= 3;
  //     $("p").css("font-size", size + "px");
  //   });
  //   $(".mediumText").on("click", function () {
  //     size += 3;
  //     $("p").css("font-size", size + "px");
  //   });
  //   $(".desktopHamberger").click(function () {
  //     $(".megaMenu").addClass("showMegaMenu");
  //   });
  //   $(".closeMenu").click(function () {
  //     $(".megaMenu").removeClass("showMegaMenu");
  //   });
  //   $("body").click(function () {
  //     $(".megaMenu").removeClass("showMegaMenu");
  //   });
  //   $(".desktopHamberger").click(function (event) {
  //     event.stopPropagation();
  //   });
  //   $(".megaMenu").click(function (event) {
  //     event.stopPropagation();
  //   });

  //   $(".navbar-toggler").click(function () {
  //     $(".menu-overlay").addClass("left0");
  //     $(".navbar-collapse").addClass("show1");
  //     $("body").addClass("removeOverflow");
  //   });
  //   $(".menu-overlay").click(function () {
  //     $(".menu-overlay").removeClass("left0");
  //     $(".navbar-collapse").removeClass("show1");
  //     $("body").removeClass("removeOverflow");
  //   });

  //   $("body").click(function () {
  //     $(".moretext").removeClass("autoHeight");
  //   });
  //   $(".card").click(function (event) {
  //     event.stopPropagation();
  //   });
  // }, []);

  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const notifyRef = useRef(null);
  const mobiledropdownRef = useRef(null);

  const [isOpentwo, setIsOpentwo] = useState(false);
  const [notifyOpen, setNotifyOpen] = useState(false);

  const useOutsideAlerter = (ref) => {
    useEffect(() => {
      function handleClickOutside(event) {
        if (notifyRef.current && !notifyRef.current.contains(event.target)) {
          setNotifyOpen(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  };

  useOutsideAlerter(notifyRef);

  const toggleDropDown = () => {
    setIsOpen(!isOpen);
  };

  const toggleTwo = () => {
    setIsOpentwo(!isOpentwo);
  };

  const toggleNotify = () => {
    setNotifyOpen(!notifyOpen);
  };

  const handleClickOut = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  const handleNotifyOut = (event) => {
    if (notifyRef.current && !notifyRef.current.contains(event.target)) {
      setNotifyOpen(false);
    }
  };
  const dropdownMobile = (event) => {
    if (
      mobiledropdownRef.current &&
      !mobiledropdownRef.current.contains(event.target)
    ) {
      setIsOpentwo(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOut);
    return () => {
      document.removeEventListener("click", handleClickOut);
    };
  }, [isOpen]);

  useEffect(() => {
    return () => {
      document.removeEventListener("click", handleNotifyOut);
    };
  }, [notifyOpen]);

  useEffect(() => {
    document.addEventListener("click", dropdownMobile);
    return () => {
      document.removeEventListener("click", dropdownMobile);
    };
  }, [isOpentwo]);

  const [scrollHeight, setScrollHeight] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      const wrapper = document.getElementsByClassName('wrapper')[0];
      if (wrapper) {
        const scrollPosition = Math.floor(window.scrollY);
        setScrollHeight(scrollPosition);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
        window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return (
    <header className="position-relative">
      <nav className={scrollHeight > 200 && isProductSolution ? "navbar-expand-lg navbar-light" : "navbar-expand-lg navbar-light fixed-top"}>
        {/* <div className="bluenav">
          <div className="container">
            <ul className="navbar-nav d-flex justify-content-end">
              <li className="nav-item align-self-center togglediv">
                <div className="form-check form-switch d-flex align-items-center">
                  <label className="form-check-label">Dark</label>

                  <input
                    className="form-check-input colorSwitch"
                    type="checkbox"
                    role="switch"
                    id="flexSwitchCheckDefault1"
                    defaultChecked="checked"
                    onClick={(e) => handleColorChange(e)}
                    checked={lightDarkMode}
                  />
                  <label
                    className="form-check-label"
                    htmlFor="flexSwitchCheckDefault1"
                  >
                    Light
                  </label>
                </div>
              </li>
              <li className="nav-item align-self-center">
                <WragMenu />
              </li>
            </ul>
          </div>
        </div> */}

        {checkTickerUrls() && homepagePromotionalData != undefined && homepagePromotionalData.display && 
          <div className="promo-container">
            <div className="container">
              <div className="d-md-flex align-items-center">
              {homepagePromotionalData && homepagePromotionalData.title &&
                <marquee direction="left" className="promotitle">
                  <div dangerouslySetInnerHTML={{__html:homepagePromotionalData.title}} />
                </marquee>
              }   
                {/* {homepagePromotionalData && homepagePromotionalData.body && 
                  <marquee direction="right"><div dangerouslySetInnerHTML={{__html:homepagePromotionalData.body}}></div></marquee>
                  } */}
                <div className="ctabuttondiv">
                  {homepagePromotionalData.cta1 && homepagePromotionalData.cta1.uri && 
                  <a href={homepagePromotionalData.cta1.uri} className="btn ctabtn-2">{homepagePromotionalData.cta1.title}</a>}
                  {homepagePromotionalData.cta1 && homepagePromotionalData.cta2.uri && 
                  <a href={homepagePromotionalData.cta2.uri} className="btn ctabtn-1">{homepagePromotionalData.cta2.title}</a>}
                </div>
              </div>
            </div>
          </div>
        }

        <div className="main-header">
          {/* <div className="desktopHamberger">
            <svg
              className="whiteHamberger"
              width="34"
              height="24"
              viewBox="0 0 34 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="0.090332"
                y="10.2856"
                width="23.1"
                height="3.42857"
                rx="1.71429"
                fill="#333333"
              />
              <rect
                x="0.090332"
                y="20.5713"
                width="33"
                height="3.42857"
                rx="1.71429"
                fill="#333333"
              />
              <rect
                x="0.090332"
                width="33"
                height="3.42857"
                rx="1.71429"
                fill="#333333"
              />
            </svg>
          </div> */}
          <button
            className="navbar-toggler border-0 p-0 menuhamburger"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            {/* <svg
              className="whiteHamberger"
              width="34"
              height="24"
              viewBox="0 0 34 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="0.090332"
                y="10.2856"
                width="23.1"
                height="3.42857"
                rx="1.71429"
                fill="#333333"
              />
              <rect
                x="0.090332"
                y="20.5713"
                width="33"
                height="3.42857"
                rx="1.71429"
                fill="#333333"
              />
              <rect
                x="0.090332"
                width="33"
                height="3.42857"
                rx="1.71429"
                fill="#333333"
              />
            </svg> */}
            <img src="/images/New/blue_hamburger.svg" className="whiteHamberger" alt="menu" width={25} height={25} />
          </button>
          <Logo />
          
          <div className="d-flex justify-content-between align-items-center w-100">
            {isDesktop && (
              <div className="menupanel">
                {leftMenu && leftMenu.length > 0 && leftMenu.map((item, index)=>(
                  <div className="menuitems" key={index}>
                    <a href={item.routeConstant} className="titles">{item.linkName}</a>
                    {item && item.linkName == "Distributor Corner" ? 
                    <div className="menudiv">
                      <div className="listmenu">
                        {item && item.childrens && item.childrens.length > 0 &&
                        item.childrens.map((childmenu, index) => (
                          childmenu && childmenu.childrens && 
                          childmenu.childrens.length > 0 &&
                          childmenu.childrens.map((subchild, subindex)=>(
                          subchild && subchild.routeConstant == null ? 
                          <a href={subchild && subchild.linkUrl} target="_blank">
                            <div className="my-2 menutitles" key={subindex}>
                              <img src={subchild.attributes && subchild.attributes.class ? subchild.attributes.class : ""} alt={subchild.attributes && subchild.attributes.alt ? subchild.attributes.alt : ""} width={24} height={24} className="me-2" />
                              {subchild && subchild.linkName}
                            </div>
                          </a>
                          :
                          subchild && subchild.linkName == "View all ->" ? 
                          <a href={subchild && subchild.routeConstant} className="viewlinks" key={subindex}> View all <img src="/images/New/Homepagestatic/md/arrow-blue.svg" alt="arrow image" /></a>
                          :
                          <a href={subchild && subchild.routeConstant}>
                            <div className="my-2 menutitles" key={subindex}>
                              <img src={subchild.attributes && subchild.attributes.class ? subchild.attributes.class : ""} alt={subchild.attributes && subchild.attributes.alt ? subchild.attributes.alt : ""} width={24} height={24} className="me-2" />
                              {subchild && subchild.linkName}
                            </div>
                          </a>
                          ))
                        ))}
                      </div>
                    </div>
                    :
                    <div className="menudiv">
                      {item && item.childrens && item.childrens.length > 0 &&
                      item.childrens.map((childmenu, index) => (
                        childmenu && childmenu.childrens && 
                        childmenu.childrens.length > 0 &&
                        childmenu.childrens.map((subchild, subindex) => (
                        <div className="listmenu" key={subindex}>
                          <p>{subchild && subchild.linkName}</p>
                          {subchild && subchild.childrens && subchild.childrens.length > 0 && (
                          subchild.childrens.length > 1 ? (
                            <div className="d-flex">
                              {subchild.childrens.map((item, itemIndex)=>(
                                <>
                                  <div className="childmenudiv" key={itemIndex}>
                                    {item && item.childrens && item.childrens.length > 0 &&
                                    item.childrens.map((children, childrenIndex) => (
                                    children && children.routeConstant == null ? 
                                    <a href={children && children.linkUrl} target="_blank">
                                      <div className="my-2 menutitles" key={childrenIndex}>
                                        <img src={children.attributes && children.attributes.class ? children.attributes.class : ""} alt={children.attributes && children.attributes.alt ? children.attributes.alt : ""} width={24} height={24} className="me-2" />
                                        {children && children.linkName}
                                      </div>
                                    </a>
                                    :
                                    children && children.linkName == "View all ->" ? 
                                      <a href={children && children.routeConstant} className="viewlinks" key={childrenIndex}> View all <img src="/images/New/Homepagestatic/md/arrow-blue.svg" alt="arrow image" /></a>
                                      :
                                      <a href={children && children.routeConstant}>
                                        <div className="my-2 menutitles" key={childrenIndex}>
                                          <img src={children.attributes && children.attributes.class ? children.attributes.class : ""} alt={children.attributes && children.attributes.alt ? children.attributes.alt : ""} width={24} height={24} className="me-2" />
                                          {children && children.linkName}
                                        </div>
                                      </a>
                                    ))}
                                  </div>
                                </>
                              ))}
                            </div>
                            ) : (
                            subchild.childrens.map((item, index)=>(
                            item && item.childrens && item.childrens.length > 0 &&
                            item.childrens.map((children, childrenIndex) => (
                              children && children.routeConstant == null ? 
                                <a href={children && children.linkUrl} target="_blank">
                                  <div className="my-2 menutitles" key={childrenIndex}>
                                    <img src={children.attributes && children.attributes.class ? children.attributes.class : ""} alt={children.attributes && children.attributes.alt ? children.attributes.alt : ""} width={24} height={24} className="me-2" />
                                    {children && children.linkName}
                                  </div>
                                </a>
                              :
                              children && children.linkName == "View all ->" ? 
                              <a href={children && children.routeConstant} className="viewlinks" key={childrenIndex}> View all <img src="/images/New/Homepagestatic/md/arrow-blue.svg" alt="arrow image" /></a>
                              :
                              <a href={children && children.routeConstant}>
                                <div className="my-2 menutitles" key={childrenIndex}>
                                  <img src={children.attributes && children.attributes.class ? children.attributes.class : ""} alt={children.attributes && children.attributes.alt ? children.attributes.alt : ""} width={24} height={24} className="me-2" />
                                  {children && children.linkName}
                                </div>
                              </a>
                            ))
                            ))
                            )
                          )}
                        </div>
                        ))
                      ))}
                    </div>}
                  </div>
                ))}
              </div>
            )}

            <div className="d-flex align-items-center ms-auto">
              <Notifications location={props} />

              <ActionMenu location={props} />

              <div className="cart1 me-1" onClick={onAddToCart}>
                <img src="/images/New/greyEcartIcon.svg" alt="e-cart" width={25} height={25}/>
                {cartDetailCookie && Object.values(cartDetailCookie)?.length > 0 && <div className='cartNotification'>
                  {Object.values(cartDetailCookie)?.length}
                </div>}
              </div>

              {isDesktop && (
                <div className="align-self-center loggindiv dropdown mx-2"
                  ref={dropdownRef}>
                  <a
                    className="d-flex align-items-center nav-link loginclass"
                    href="#"
                    id="navbarDropdown"
                    //role="button" data-bs-toggle="dropdown" aria-expanded="false"
                    onClick={toggleDropDown}
                  >
                    Login
                  </a>
                  {isOpen && (
                    <div
                      className="dropdown-body px-3 logincls"
                      aria-labelledby="navbarDropdown"
                      style={{ borderRadius: "15px" }}
                    >
                      <a
                        href="https://investor-web.hdfcfund.com/"
                        target="_blank"
                        className="dropdown-item fw-bold"
                      >
                        Investor
                      </a>
                      <hr className="dropdown-divider"></hr>
                      <a
                        href="https://distributor.hdfcfund.com/"
                        target="_blank"
                        className="dropdown-item fw-bold"
                      >
                        Distributor
                      </a>
                    </div>
                  )}
                </div>
              )}

              {isDesktop && (
                // <div className="align-self-center investorbtn">
                  <a
                    className="nav-link btn-blue align-self-center  "
                    href="https://investor-web.hdfcfund.com/new-investor"
                    target="_blank"
                    rel="noreferrer"
                  >
                    New Investor
                  </a>
                // </div>
              )}

              {isDesktop == false && (
              <div className="position-relative investorlink"
                ref={mobiledropdownRef}
              >
                <div className="profilediv d-flex align-items-center"
                  onClick={toggleTwo}
                >
                  <img src="/images/New/profile.svg" alt="profile" width={25} height={25}/>
                  <img src="/images/New/grey_down_arrow.svg" alt="dropdown" width={15} height={25} />
                </div>
                {
                  isOpentwo && (
                    <ul className="prosite">
                      <li>
                        <a href="https://investor-web.hdfcfund.com/" target="_blank">
                          Investor
                        </a>
                      </li>
                      <li>
                        <a href="https://distributor.hdfcfund.com/" target="_blank">
                          Distributor
                        </a>
                      </li>
                      {/* <li>
                        <a href="https://investor-web.hdfcfund.com/new-investor" target="_blank">
                          New Investor
                        </a>
                      </li> */}
                    </ul>
                  )
                }
              </div>)}
            </div>
          </div>

          {/* {isDesktop == false && (<ul class="ms-auto mobileHeadIcons">
            <li className="me-1">
              <a
                className="nav-link btn-blue"
                href="https://investor-web.hdfcfund.com/new-investor"
                target="_blank"
                rel="noreferrer"
              >
                Start SIP
              </a>
            </li>
            <ActionMenu location={props} />
            <li className="nav-item align-self-center">
              <div className="position-relative ms-1"
                ref={mobiledropdownRef}
              >
                <div className="profilediv d-flex align-iitems-center"
                  onClick={toggleTwo}
                >
                  <img src="/images/New/profile.svg" alt="profile icon" width={25} height={25}/>
                  <img src="/images/New/blue_down_arrow.svg" alt="blue down arrow icon" width={25} height={25} />
                </div>
                {
                  isOpentwo && (
                    <ul className="prosite">
                      <li>
                        <a href="https://investor-web.hdfcfund.com/" target="_blank">
                          Login
                        </a>
                      </li>
                      <li>
                        <a href="https://investor-web.hdfcfund.com/new-investor" target="_blank">
                          New Investor
                        </a>
                      </li>
                    </ul>
                  )
                }
              </div>
            </li>
          </ul>)} */}
          <div className="menu-overlay" />
          <div
            className="collapse navbar-collapse clearfix"
            id="navbarSupportedContent"
          >
            {/* {isDesktop && (<div className="desktopHeader justify-content-end">
              <ul className="navbar-nav me-auto">
                <ActionMenu location={props} />
              </ul>
              <ul className="navbar-nav">
                <Notifications location={props} />
                <li className="nav-item align-self-center dropdown">
                  <a
                    className="nav-link btn-blue"
                    href="https://investor-web.hdfcfund.com/new-investor"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Start SIP
                  </a>
                </li>
                <li
                  className="nav-item align-self-center dropdown"
                  ref={dropdownRef}
                >
                  <a
                    className="d-flex align-items-center nav-link loginclass"
                    href="#"
                    id="navbarDropdown"
                    //role="button" data-bs-toggle="dropdown" aria-expanded="false"
                    onClick={toggleDropDown}
                  >
                    Login
                    <img
                      // src="/images/New/red-arrow.svg"
                      src="/images/New/blue_arrow.svg"
                      className="ms-2"
                      alt="blue arrow icon"
                      width={15}
                      height={15}
                    />
                  </a>
                  {isOpen && (
                    <div
                      className="dropdown-body px-3 logincls"
                      aria-labelledby="navbarDropdown"
                      style={{ borderRadius: "15px" }}
                    >
                        <a
                          href="https://investor-web.hdfcfund.com/"
                          target="_blank"
                          className="dropdown-item fw-bold"
                        >
                          Investor
                        </a>
                        <hr class="dropdown-divider"></hr>
                        <a
                          href="https://distributor.hdfcfund.com/"
                          target="_blank"
                          className="dropdown-item fw-bold"
                        >
                          Distributor
                        </a>
                    </div>
                  )}
                </li>
                
                <li className="nav-item align-self-center togglediv">
                  <div className="form-check form-switch d-flex align-items-center darkmodetoggle">
                    <label className="form-check-label">Dark</label>
                    <input
                      className="form-check-input colorSwitch"
                      type="checkbox"
                      role="switch"
                      id="flexSwitchCheckDefault1"
                      defaultChecked="checked"
                      onClick={(e) => handleColorChange(e)}
                      checked={lightDarkMode}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexSwitchCheckDefault1"
                    >
                      Light
                    </label>
                  </div>
                  <div>
                    <WragMenu />
                  </div>
                </li>

                <li className="nav-item align-self-center">
                  <div className="cart1" onClick={onAddToCart}>
                  <img src="/images/New/blue_ecart.svg" alt="e-cart" width={25} height={25}/>
                    {cartDetailCookie && Object.values(cartDetailCookie)?.length > 0 && <div className='cartNotification'>
                      {Object.values(cartDetailCookie)?.length}
                    </div>}
                  </div>
                </li>
              </ul>
            </div>)} */}
            {isDesktop == false && (<div class="mobileHeader">
              <div className="mb-4 pb-2 d-flex mobiletoggle">
                <div class="form-check darkmodetoggle mx-1">
                  {/* <label class="form-check-label">Dark</label> */}
                  <input
                    className="form-check-input"
                    type="checkbox"
                    role="switch"
                    id="flexSwitchCheckDefault"
                    defaultChecked="checked"
                    onClick={(e) => handleColorChange(e)}
                    checked={lightDarkMode}
                    aria-label="Toggle light/dark mode"
                  />
                  {/* <label class="form-check-label" for="flexSwitchCheckDefault">
                    Light
                  </label> */}
                </div>

                <WragMenu />
              </div>
              {/* <ul className="mobileHeadIcons mb-3">
              <li class="nav-item align-self-center dropdown mb-md-2" ref={notifyRef}>
                <a
                  className="nav-link p-0"
                  id="navbarDropdown3"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  onClick={toggleNotify}
                  aria-label="Bell icon"
                >
                  <img src="/images/New/NotificationIcon.svg" className="notify-icon" width={25} height={25} alt="notification icon" loading="lazy"/>
                </a>
                {notifyOpen && (
                  <ul
                    className="dropdown-body px-3 notifydrop"
                    aria-labelledby="navbarDropdown3"
                    style={{
                      borderRadius: "15px",
                      maxHeight: "280px",
                      overflowY: "auto",
                    }}
                  >
                    {notificationData &&
                      notificationData.notifications &&
                      notificationData.notifications.length > 0 &&
                      notificationData.notifications.map((item, i) => (
                        <>
                          {" "}
                          <li>
                            <a
                              href={
                                item.link.suggestedUrl && __CLIENT__
                                  ? "/" + item.link.suggestedUrl
                                  : item.link.uri
                              }
                              target="_blank"
                              className="dropdown-item text-wrap"
                            >
                              {item.description}
                              <p>{item.date}</p>
                            </a>
                          </li>
                          <li>
                            <hr class="dropdown-divider"></hr>
                          </li>
                        </>
                      ))}
                  </ul>
                )}
                
              </li>
              <li onClick={onAddToCart} className='cart1 nav-item align-self-center'>
                <img src="/images/New/blue_ecart.svg" alt="e-cart" width={25} height={25}/>
                {cartDetailCookie && Object.values(cartDetailCookie)?.length > 0 && <div className='cartNotification'>
                  {Object.values(cartDetailCookie)?.length}
                </div>}
              </li>
              </ul> */}
              {/* <div class="mb-4 pb-2 d-flex justify-content-center mobiletoggle">
                <div class="form-check form-switch ps-0">
                  <label class="form-check-label">Dark</label>
                  <input
                    className="form-check-input colorSwitch"
                    type="checkbox"
                    role="switch"
                    id="flexSwitchCheckDefault"
                    defaultChecked="checked"
                    onClick={(e) => handleColorChange(e)}
                    checked={lightDarkMode}
                  />
                  <label class="form-check-label" for="flexSwitchCheckDefault">
                    Light
                  </label>
                </div>
                <WragMenu />
              </div> */}
              {/* <div class="d-flex bdrBtm">
                <div class="me-auto">
                  <a
                    class="nav-link btn-blue inveBtn"
                    href="https://investor-web.hdfcfund.com/new-investor"
                  >
                    New Investor
                  </a>
                </div>
                <div
                  class=" align-self-center dropdown"
                  ref={mobiledropdownRef}
                >
                  <a
                    class="d-flex logIn"
                    href="#"
                    id="navbarDropdown2"
                    role="button"
                    // data-bs-toggle="dropdown"
                    // aria-expanded="false"
                    onClick={toggleTwo}
                  >
                    Login
                    <img
                      className="ms-2"
                      src="/images/New/red-arrow.svg"
                      alt="red arrow icon"
                      width={15}
                      height={15}
                    />
                  </a>
                  {isOpentwo && (
                    <ul
                      className="dropdown-body px-3"
                      // aria-labelledby="navbarDropdown2"
                      style={{ borderRadius: "15px" }}
                    >
                      <li>
                        <a
                          href="https://investor-web.hdfcfund.com/"
                          target="_blank"
                          className="dropdown-item fw-bold"
                        >
                          Investor
                        </a>
                      </li>
                      <li>
                        <hr class="dropdown-divider"></hr>
                      </li>
                      <li>
                        <a
                          href="https://distributor.hdfcfund.com/"
                          target="_blank"
                          className="dropdown-item fw-bold"
                        >
                          Distributor
                        </a>
                      </li>
                    </ul>
                  )}
                </div>
              </div> */}
              {isDesktop == false && (<MobileNavbar />)}
            </div>)}
          </div>
        </div>
        {/* {isDesktop && (<div className="bluenav">
          <div className="container">
            <div className="accordianMenu">
                {
                  leftMenu && leftMenu.length > 0 && leftMenu.map((item, index) => (
                  <>
                  {
                    item && item.childrens[0] == undefined ? (
                      <div className="item px-2 title" 
                        // onMouseLeave={() => setSelected(null)}
                      >
                          {
                            item.linkUrl !== "/" ? (
                              <a href={item.linkUrl} className="d-flex py-2">
                                <p className="titleactive me-2">{item.linkName ? item.linkName : ""}</p>
                              </a>
                            ) : (
                              <a 
                                href={item.routeConstant}
                                className="d-flex py-2"
                              >
                                <p className="titleactive me-2">{item.linkName ? item.linkName : ""}</p>
                              </a>
                          )
                          }
                      </div>
                    ) : (
                      // <div className="">
                      <div className="item px-2 title" 
                        // onMouseLeave={() => setSelected(null)}
                      >
                        <a href={item.routeConstant}
                          // to={getRouting(item.routeConstant)} 
                          // onClick={() => selected(null)}
                          className="d-flex align-items-center py-2"
                        >
                          <p className="titleactive me-2" >{item.linkName ? item.linkName : ""}</p>
                          <img src="/images/New/WhiteArrow.svg" alt="white arrow" className="menuimg"  width={13} height={13} />
                        </a>
                          <div className="contentmenu container"
                            // className={selected === index ? 
                            // "contentmenu container showmenu" : "container contentmenu"} 
                          >
                              {
                                item && item.childrens && item.childrens.length > 0 &&
                                item.childrens.map((childmenu, index) => (
                                  <>
                                    {
                                      childmenu && childmenu.childrens && 
                                      childmenu.childrens.length > 0 &&
                                      childmenu.childrens.map((subchild, subindex) => (
                                        <>
                                          {
                                            subchild && subchild.childrens &&
                                            subchild.childrens.length > 0 ? (
                                              <div className="menupannel">
                                                  <h3 className="menutitle">
                                                  {subchild && subchild.routeConstant == null && subchild.linkUrl == "/" ? subchild.linkName ? subchild.linkName : "" : (
                                                      <a href={subchild.routeConstant} className="menutitle">
                                                        {subchild.linkName ? subchild.linkName : ""} 
                                                      </a>   
                                                    )}  
                                                  </h3>
                                                
                                                <div className="row">
                                                  {
                                                    subchild && subchild.childrens &&
                                                    subchild.childrens.length > 0 &&
                                                    subchild.childrens.map((item, index) => (
                                                      <>
                                                        {
                                                          item && item.childrens && item.childrens.length > 0 ? (
                                                            <>
                                                            {
                                                              item && item.childrens && item.childrens.length > 0 &&
                                                              item.childrens.map((children, index) => (
                                                                <div className="col-4 mb-3 childclass d-flex contenttext align-items-center">
                                                                      <Link to={getRouting(children.routeConstant)} onClick={() => selected(null)} className="me-3"  >
                                                                        <img src={children.attributes && children.attributes.class ? children.attributes.class : ""} width={24} height={24} alt={children.attributes && children.attributes.alt ? children.attributes.alt : ""} />
                                                                      </Link>
                                                                      <Link to={getRouting(children.routeConstant)} onClick={() => selected(null)} >
                                                                        <p>{children.linkName ? children.linkName : ""}</p>
                                                                      </Link>
                                                                </div>
                                                            ))
                                                            }
                                                            </>
                                                          ) : (
                                                            <div className="col-4 mb-3 contenttext d-flex dfd align-items-center">
                                                                  <Link to={getRouting(item.routeConstant)} onClick={() => selected(null)}  className="me-3"  >
                                                                    <img src={item.attributes && item.attributes.class ? item.attributes.class : ""} alt={item.attributes && item.attributes.alt ? item.attributes.alt : ""} width={24} height={24} loading="lazy"/>
                                                                  </Link>
                                                                  <Link to={getRouting(item.routeConstant)} onClick={() => selected(null)} >
                                                                  <p>{item.linkName ? item.linkName : ""}</p>
                                                                  </Link>
                                                            </div>
                                                          )
                                                        }
                                                      </>
                                                    // <div className="col-4 mb-3">
                                                    //   {console.log("item", item)}
                                                    //   <Link to={getRouting(item.routeConstant)} onClick={() => selected(null)} >
                                                    //     <div className="d-flex contenttext align-items-center">
                                                    //       <img src="/images/HomePage/MfGlance.svg" className="me-3" />
                                                    //       <p>{item.linkName ? item.linkName : ""}</p>
                                                    //     </div>
                                                    //   </Link>
                                                    // </div>
                                                    ))
                                                  }
                                                    
                                                </div>
                                              </div>
                                            ) : 
                                            (
                                              <div className="menupannel">
                                                {
                                                  subchild.linkUrl !== "/" ? (
                                                      <h3 className="menutitle">
                                                        {subchild && subchild.routeConstant == null && subchild.linkUrl == "/" ? subchild.linkName ? subchild.linkName : "" : (
                                                          <a href={subchild.linkUrl} target="_blank" className="menutitle">
                                                            {subchild.linkName ? subchild.linkName : ""}
                                                          </a>    
                                                        )}  
                                                      </h3>
                                                  ) : (
                                                    <h3 className="menutitle">
                                                      {subchild && subchild.routeConstant == null && subchild.linkUrl == "/" ? subchild.linkName ? subchild.linkName : "" : (
                                                        <Link to={getRouting(subchild.routeConstant)} 
                                                        // href={subchild.routeConstant}
                                                        onClick={() => selected(null)}
                                                        className="menutitle"
                                                        >
                                                          {subchild.linkName ? subchild.linkName : ""}
                                                        </Link>
                                                      )}
                                                    </h3>
                                                  )
                                                }
                                                
                                              </div>
                                            )
                                          }
                                        </>
                                      ))
                                    }
                                  </>
                                ))
                              }
                          </div>
                      </div>
                      // </div>
                      )
                    }
                  </>
                  ))
                }
            </div>
          </div>
        </div>)} */}

      </nav>

      {isDesktop && (<div className="align-self-center togglediv">
        <div className="form-check d-flex align-items-center darkmodetoggle">
          <input
            className="form-check-input"
            type="checkbox"
            role="switch"
            id="flexSwitchCheckDefault"
            defaultChecked="checked"
            onClick={(e) => handleColorChange(e)}
            checked={lightDarkMode}
            aria-label="Toggle light/dark mode"
          />
        </div>
        <div>
          <WragMenu />
        </div>
      </div>)}

      {/* <WragMenu /> */}
      {/* <Navigation /> */}
    </header>
  );
};

const mapStateToProps = (state) => ({
  commonContent: state.commonContent,
  getMenus: state.commonContent.menu.headerMenu,
  updatesAndNotifications: state.commonContent.menu.updatesAndNotifications,
  promotionalBannerTop: state.commonContent.promotionHeader,
});

const mapDispatchToProps = (dispatch) => ({
  getMenu: bindActionCreators(getMenu, dispatch),
  closePopup: bindActionCreators(closePopup, dispatch),
  openPopup: bindActionCreators(openPopup, dispatch),
  updateEcartDetails: bindActionCreators(updateEcartDetails, dispatch),
  promotionalHeader: bindActionCreators(promotionalHeader, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);
